import './SubtitleSection.css'

const SubtitleSection = ({ subtitleSection }) => {
  return (
    <>
      <h2 className="subtitleSection">{subtitleSection}</h2>
    </>
  );
};

export default SubtitleSection;
